<script setup>
import { DatePicker } from 'v-calendar';
import 'v-calendar/style.css';
import { computed } from 'vue';
import moment from 'moment';

const props = defineProps({
  modelValue: {
    type: [String, Date],
    default: null,
  },
});

const value = computed(() => {
  if (typeof props.modelValue === 'string') {
    return moment.utc(props.modelValue).toDate();
  }

  return props.modelValue;
});

const emit = defineEmits(['update:modelValue']);
</script>

<template>
  <DatePicker
    :model-value="value"
    @update:modelValue="$emit('update:modelValue', $event)"
    v-bind="$attrs"
    timezone="UTC"
    popover
  >
    <template v-slot="{ inputValue, inputEvents, showPopover }">
      <div class="position-relative">
        <input @click="showPopover" :value="inputValue" class="form_field" readonly style="display: inline-block" />
        <svg v-if="value !== null" @click="$emit('update:modelValue', null)" class="icon close_icon">
          <use xlink:href="#close"></use>
        </svg>
      </div>
    </template>
  </DatePicker>
</template>

<style scoped>
.close_icon {
  width: 20px;
  height: 20px;
  position: absolute;
  display: inline-block;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  cursor: pointer;
  box-sizing: content-box;
  padding: 6px 12px;
  z-index: 2;
}
</style>
